import  groq  from 'groq';

export const ABOUT_US_QUERY = groq`
  *[_type == "aboutUs" && isActive == true][0] {
    _id,
    title,
    description,
    image {
      asset->{
        url,
        metadata {
          dimensions
        }
      },
      alt
    },
    isActive
  }
`;

export const localizedAboutUsQuery = (locale: string) => groq`
  *[_type == "aboutUs" && isActive == true][0] {
    _id,
    title,
    description,
    image {
      asset->{
        url,
        metadata {
          dimensions
        }
      },
      alt
    },
    isActive
  }
`;
